module.exports = __webpack_public_path__ + "videos/auto-webinars.a15390f.webm";